export default __webpack_public_path__ + "static/media/SportKLS_Posterior.862f9429.webp";